import { Takeover } from '@/components/ui/Takeover';
import { MessageThread } from '@/pages/MessageThread';

/**
 * Full-screen takeover for a discussion thread. Overlays the current page instead
 * of navigating to the thread route, so the user keeps their place on the
 * discussions list.
 */
export function MessageThreadTakeover({
  threadId,
  projectId,
  typeSlug,
  onClose,
}: {
  threadId: string;
  projectId: string;
  typeSlug?: string;
  onClose: () => void;
}) {
  return (
    <Takeover onClose={onClose} maxWidthClass="max-w-[70rem]">
      <MessageThread threadId={threadId} projectId={projectId} typeSlug={typeSlug} onClose={onClose} />
    </Takeover>
  );
}
